import { useProject } from '@/features/project/_hooks/project';
import { useId } from '@/hooks';
import type { FC, PropsWithChildren } from 'react';

export const ProjectDisplayGuard: FC<PropsWithChildren> = ({ children }) => {
  const { id } = useId();
  const project = useProject(id);

  if (project.isPending || !project.data) {
    return null;
  }

  return <>{children}</>;
};
